import log from '@itbelcom/log';


var ERRORS = {
    MAIN:  { status: -100, errorMsg: 'ПО для работы с ЭЦП не отвечает.' },
    ABORT: { status: -101, errorMsg: '', statusAbort: true },
    WRONG: { status: -102, errorMsg: 'Получены неверные данные от сервера.' },
};


export function DigitalSign(o) {
    var that = this;

    var _options = Object.assign({
        version: '1.0.0',
        defaultMessage: 'DigitalSignMessage',
    }, o);


    if (!_options.baseUrl) {
        throw new Error('*** @itbelcom/DigitalSign:: <baseUrl> option is required.');
    }

    if (typeof _options.ajax !== 'function') {
        throw new Error('*** @itbelcom/DigitalSign:: <ajax> option is not valid.');
    }


    that.getDefaultMessage = getDefaultMessage;
    that.getKeyContainerNames = getKeyContainerNames;
    that.getOptions = getOptions;
    that.getVersions = getVersions;
    that.signMessage = signMessage;


    function _strToBytes(value) {
        var i, code, bytes = []; // char codes

        for (i = 0; i < value.length; ++i) {
            code = value.charCodeAt(i);
            bytes.push(code & 0xff, code / 256 >>> 0);
            //////////////bytes = bytes.concat([code & 0xff, code / 256 >>> 0]);
        }
        return bytes;
    } /* _strToBytes */


    function parseResponseError(response) {
        var error;
        var data = response.data || {};

        if (response.xhrStatus === 'abort') {
            error = {
                status: ERRORS.ABORT.status,
                errorMsg: ERRORS.ABORT.errorMsg
            };
        } else {
            error = {
                status: response.status || ERRORS.MAIN.status,
                errorMsg: data.error || response.statusText || ERRORS.MAIN.errorMsg
            };
        }

        //console.log('*** @itbelcom/DigitalSign:: parseResponseError 3: ERROR: error =', error);
        return Promise.reject(error);
    } /* parseResponseError */


    function parseResponseSuccess(response) {
        var data = response.data || {};

        //console.log('*** @itbelcom/DigitalSign:: parseResponseSuccess 1: RESPONSE: data =', data);
        if ((response.status >= 200) && (response.status <= 299)) {
            return response;
        } else {
            data = {
                status: response.status || ERRORS.MAIN.status,
                errorMsg: data.error || response.statusText || ERRORS.MAIN.errorMsg
            };
            //console.log('*** @itbelcom/DigitalSign:: parseResponseSuccess 2: ERROR: data =', data);
            return Promise.reject(data);
        }
    } /* parseResponseSuccess */


    function getDefaultMessage() {
        return _options.defaultMessage;
    } /* getDefaultMessage */


    function getKeyContainerNames() {
        //console.log('*** @itbelcom/DigitalSign.getKeyContainerNames: START:');

        var timeName = 'DigitalSign.getKeyContainerNames(...) <LWS>';
        return log.timeProc(timeName, function() {
            return _options.ajax({
                method: 'GET',
                url: _options.baseUrl + 'getKeyContainerNames',
                withCredentials: _options.withCredentials
            });
        })
        .then(parseResponseSuccess, parseResponseError)
        .then(function(response) {
            return response.data.containers || [];
        }, function(error) {
            log.error(timeName + ' ==> ' + error.errorMsg);
            return Promise.reject(error);
        });
    } /* getKeyContainerNames */


    function getOptions() {
        return Object.assign({}, _options);
    } /* getOptions */


    function getVersions() {
        //console.log('*** @itbelcom/DigitalSign.getVersion: START:');

        var timeName = 'DigitalSign.getVersions(...) <LWS>';
        return log.timeProc(timeName, function() {
            return _options.ajax({
                method: 'GET',
                url: _options.baseUrl + 'getVersion',
                withCredentials: _options.withCredentials
            });
        })
        .then(parseResponseSuccess, parseResponseError)
        .then(function(response) {
            var data = response.data || {};
            return {
                jsModule: _options.version,
                localServer: {
                    fileVersion: data.fileVersion || 'неопределено',
                    productVersion: data.productVersion || 'неопределено'
                }
            };
        }, function(error) {
            log.error(timeName + ' ==> ' + error.errorMsg);
            return Promise.reject(error);
        });
    } /* getVersion */


    function signMessage(message, container, password) {
        //console.log('*** @itbelcom/DigitalSign.signMessage:: START:');
        if (!message) {
            return Promise.reject({
                status: -204,
                errorMsg: 'Нельзя подписать пустое сообщение'
            });
        }

        var timeName = 'DigitalSign._strToBytes(...); typeof = ' + typeof(message) + '; length = ' + message.length;
        log.time(timeName);
        var byteArray = (typeof(message) === 'string') ? _strToBytes(message) : message;
        log.timeEnd(timeName);

        timeName = 'DigitalSign.signMessage(...) <LWS>';
        return log.timeProc(timeName, function() {
            return _options.ajax({
                method: 'POST',
                url: _options.baseUrl + 'signMessage',
                withCredentials: _options.withCredentials,
                data: {
                    message: byteArray, //message,
                    container: container,
                    password: password
                }
            });
        })
        .then(parseResponseSuccess, parseResponseError)
        .then(function(response) {
            return {
                password: password,
                byteArray: byteArray,
                signature: response.data.signature
            };
        }, function(error) {
            log.error(timeName + ' ==> ' + error.errorMsg);
            return Promise.reject(error);
        });
    } /* signMessage */

} /* DigitalSign */



//////////////////
// WEBPACK FOOTER
// ../node_modules/@itbelcom/digital-sign/src/digital-sign.js
// module id = 716
// module chunks = 0 1 2